export default "__VITE_ASSET__8UlDJwnG__"